import React from "react"
import Box from "@material-ui/core/Box"
import Footer from "./footer"
import { makeStyles } from "@material-ui/core/styles"
import AppBar from "@material-ui/core/Toolbar"
import Toolbar from "@material-ui/core/Toolbar"
import SocialButtons from "./social-buttons"
import { ParallaxProvider } from "react-scroll-parallax"
import { Hidden, Button } from "@material-ui/core"
import { navigate } from "gatsby"
import "./layout.css"

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  containerMain: {
    minHeight: "100vh",
    backgroundColor: "#fff",
    background: "linear-gradient(-45deg, #EE7752, #E73C7E, #23A6D5, #23D5AB)",
    animation: "Gradient 15s ease infinite",
    backgroundSize: "400% 400%",
    padding: 0,
    margin: 0,
    color: "#fff",
    marginBottom: -30,
  },
  title: {
    flexGrow: 1,
  },
}))

const Layout = props => {
  const { children } = props
  const classes = useStyles()

  const nav = event => {
    event.preventDefault()
    navigate("/blog")
  }

  return (
    <React.Fragment>
      <Box id="main-Box" className={classes.containerMain}>
        <div className={classes.root}>
          <AppBar position="static">
            <Toolbar style={{ flex: 1, zIndex: 10 }}>
              <span className={classes.title} />

              <Hidden xsDown>
                <SocialButtons youtube={true} fromLanding={true} />
              </Hidden>
              <Button style={{ color: "white" }} onClick={e => nav(e)}>
                {"Blog"}
              </Button>
            </Toolbar>
          </AppBar>
        </div>

        <ParallaxProvider>
          <Box>
            <main>{children}</main>
          </Box>
        </ParallaxProvider>
      </Box>
      <Footer fromLanding={true} />
    </React.Fragment>
  )
}

export default Layout
